import React, { useEffect, useState } from 'react';
import { Image } from '@ruter-ds/rds-components';
import imageRequest from '../util/imageRequest';

export const RuterStoppsImage = ({ src, ...rest }) => {
    const [imageBlob, setImageBlob] = useState();

    useEffect(() => {
        imageRequest(src).then((res) => setImageBlob(res));
    }, [src]);

    if (!imageBlob) {
        return null;
    }

    return <Image src={imageBlob} {...rest} />;
};
